export default "__VITE_ASSET__CuB0nhwc__"